import * as React from 'react';
import FAB from '../../FAB';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChalkboardTeacher,
  faChartLine,
  faCog,
  faComment,
  faCubes,
  faLayerGroup,
  faLocationDot,
  faMap,
} from '@fortawesome/free-solid-svg-icons';
import { navigate } from 'gatsby';

function MainMenu() {
  const actions = [
    {
      label: 'Flashcards',
      icon: <FontAwesomeIcon icon={faLayerGroup} color="black" />,
      onClick: () => navigate('/flashcards/'),
    },
    {
      label: 'Grammar',
      icon: <FontAwesomeIcon icon={faChalkboardTeacher} color="black" />,
      onClick: () => navigate('/grammar/'),
    },
    {
      label: 'Decks',
      icon: <FontAwesomeIcon icon={faCubes} color="black" />,
      onClick: () => navigate('/collections'),
    },
    {
      label: 'Stats',
      icon: <FontAwesomeIcon icon={faChartLine} color="black" />,
      onClick: () => navigate('/progress'),
    },
    {
      label: 'Settings',
      icon: <FontAwesomeIcon icon={faCog} color="black" />,
      onClick: () => navigate('/settings'),
    },
  ];

  return <FAB actions={actions} />;
}

export default MainMenu;
